module.exports = __webpack_public_path__ + "static/img/wall-conveyor-x2_256.140f799.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wall-conveyor-x2_256.png
// module id = c3Py
// module chunks = 0